module.exports = __webpack_public_path__ + "img/bigwin-last.355147ec.png";